var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.313,
    height: 40.313,
    viewBox: "0 0 40.313 40.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play_White",
    "data-name": "Play White",
    transform: "translate(-167.344 -578.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_449",
    "data-name": "Elipse 449",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(175 586)",
    fill: "#454f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play-circle",
    "data-name": "Icon ionic-ios-play-circle",
    d: "M23.531,3.375A20.156,20.156,0,1,0,43.688,23.531,20.153,20.153,0,0,0,23.531,3.375Zm8.121,20.534-13.3,8.043a.431.431,0,0,1-.649-.378V15.488a.429.429,0,0,1,.649-.378l13.3,8.043A.444.444,0,0,1,31.652,23.909Z",
    transform: "translate(163.969 575.125)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhite);
export default __webpack_public_path__ + "static/media/play_white.1bee620a6baaff94d7e636e52d695cbb.svg";
export { ForwardRef as ReactComponent };